var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 7,
    viewBox: "0 0 14 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7887 1.10953L7.4611 6.83686C7.2175 7.05438 6.8522 7.05438 6.6084 6.83686L0.21038 1.10953C-0.0505199 0.839076 -0.0715987 0.473164 0.163052 0.210662C0.412817 -0.0637726 0.815303 -0.0597952 1.06308 0.162934L6.99975 5.50844L12.9376 0.162934C13.1999 -0.0708123 13.6014 -0.0502899 13.8372 0.210184C14.0711 0.473164 14.0512 0.839076 13.7887 1.10953Z",
    fill: "#363636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDOWN.2c830e67c8387c0a9a050fd3a9cfae07.svg";
export { ForwardRef as ReactComponent };